import { useParams, Navigate } from "react-router-dom";
import Seo from "@/lib/Seo";
import PageHero from "@/components/common/PageHero";
import FormationCard from "@/components/common/FormationCard";
import { getCategory, getFormationsByCategory } from "@/data/formations";

export default function FormationCategory() {
  const { category } = useParams();
  const cat = getCategory(category);
  if (!cat) return <Navigate to="/nos-formations" replace />;

  const formations = getFormationsByCategory(category);

  return (
    <>
      <Seo
        title={cat.title}
        description={`${cat.title} — ${cat.baseline} Formations certifiantes EDUCASER GROUP.`}
        path={`/nos-formations/${cat.slug}`}
        image={cat.image}
      />
      <PageHero
        breadcrumb={[
          { label: "Accueil", to: "/" },
          { label: "Nos formations", to: "/nos-formations" },
          { label: cat.title },
        ]}
        eyebrow="Domaine de formation"
        title={cat.title}
        intro={cat.baseline}
      />

      <div className="bg-white py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {formations.map((f, i) => (
              <FormationCard key={f.slug} formation={f} categorySlug={cat.slug} index={i} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
